const $ = require('cash-dom');
const Ajax = require('./ajax');
const popup = require('./popup');
const Page = require('./page');
const Validator = require('./validator');

const WriteReview = {
  init() {
    $(document.body).on('click', '.submit-review', function () {
      let $btn = $(this),
        $form = $btn.parents('.review-form'),
        formData = new FormData($form.get(0));

      if ($btn.hasClass('process')) {
        return false;
      }

      $btn.addClass('process');
      Page.startLoad('submit-review', $btn);
      Validator.removeErrors($form);

      formData.set('review-email', $('#review-email').val());
      formData.set('review-author', $('#review-author').val());

      Ajax.post(ajaxurl + '?action=submit-user-review', formData, function (result) {
        Page.finishLoad('submit-review');

        //validation errors
        if (typeof result.errors !== 'undefined' && result.errors.length > 0) {
          Validator.validate($form, result.errors);
        }

        //show popup with email and name
        if (typeof result.success !== 'undefined' && result.success === true &&
          typeof result.additional_fields !== 'undefined' && result.additional_fields === true) {

          $('[name="only-validation"]').remove();

          $('.navigation, .breadcrumbs, #content, .footer').addClass('blurred');
          popup.show($('#write-review-additional').html());
        } else if (typeof result.success !== 'undefined' && result.success === true && typeof result.redirect !== 'undefined') {
          //everything is good, review added
          window.location.href = result.redirect;
        }

        $btn.removeClass('process');

      }, 'json');

      return false;
    });

    $(document.body).on('click', '#submit-additional-form', function () {
      $('.submit-review').trigger('click');
      popup.hide();
      return false;
    });
  },
};

module.exports = WriteReview;
